module.exports = __webpack_public_path__ + "media/images/sales/early/eyecatch-early-01-9d6765de85b96769a3df8d9dfaaca453.svg";